export const formContent = {
    payID: {
        id: 'payId',
        label: 'Pay Id',
        type: "text",
    },
    EFTAccountName: {
        id: 'EFTAccountName',
        label: 'EFT account name',
        type: "text",
    },
    EFTAccountNumber: {
        id: 'EFTAccountNumber',
        label: 'EFT account number',
        type: "text",
    },
    eftBSB: {
        id: 'eftBSB',
        label: 'EFT account BSB',
        type: "text",
    },
    updateButton: {
        id: 'updateButton',
        label: 'Update payment Methods',
        type: 'submit'
    },
    createButton: {
        id: 'createButton',
        label: 'Add payment Methods',
        type: 'submit'
    }
}
